import { Route, Routes } from "react-router-dom";
import QuizList from "./QuizList";
import CreateQuiz from "./CreateQuiz";
import ManageQuiz from "./ManageQuiz";
import QuizMetricsDashboard from "./metrics/QuizMetricsDashboard";

const QuizHome = () => {
  return (
    <Routes>
      <Route path="/" element={<QuizList />} />
      <Route path="create" element={<CreateQuiz />} />
      <Route path=":quizId" element={<ManageQuiz />} />
      <Route path=":quizId/metrics" element={<QuizMetricsDashboard />} />
    </Routes>
  );
};

export default QuizHome;